const messages = {
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_FD.title': 'PRE / FD',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_FD.excerpt':
    'Pre-Money-Valuation / fully-diluted share capital',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_ND.title': 'PRE / ND',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_ND.excerpt':
    'Pre-Money-Valuation / non-diluted share capital',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_INC_CNS_FD.title': 'PRE / (FD+CNs)',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_INC_CNS_FD.excerpt':
    'Pre-Money-Valuation / fully diluted share capital inc. potential conversions',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_INC_CNS_ND.title': 'PRE / (ND+CNs)',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_INC_CNS_ND.excerpt':
    'Pre-Money-Valuation / share capital inc. potential conversions',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_AS_IF_FD.title': 'PRE-AS-IF / FD',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_AS_IF_FD.excerpt':
    'Pre-Money-as-if-converted / fully diluted share capital',
  'defaultPriceCalculationMethods.MANUAL_PRICE.title': 'MANUAL',
  'defaultPriceCalculationMethods.MANUAL_PRICE.excerpt':
    'No automatic calculation of the price in bulk edits',

  'conversionBulkTable.automaticCalculation.title':
    'Calculate shares and discounted prices automatically',
  'conversionBulkTable.automaticCalculation.excerpt':
    'If checked, we calculate the discounted price and number of shares for each conversion automatically based on the different convertible note parameters. The prices of the convertibel notes are determined based on the selected calculation method and possible discounts/pre-money-caps. Note that all conversions in the table are updated if this box is checked, including already customized share numbers.',

  'equityBulkTable.numberOfShares.title': 'Number of shares based on share prices.',
  'equityBulkTable.numberOfShares.excerpt':
    'If checked, we calculate the number of shares for each investment automatically based on the different share classes. The prices of the share classes are determined based on the selected calculation method. Note that all equity investments in the table are updated if this box is checked, including already customized share numbers.',

  'entity.CnInvestment.convertibleNote.forcedPaymentOnConversion.title':
    'Supplementary payment amount',
  'entity.CnInvestment.convertibleNote.forcedPaymentOnConversion.excerpt':
    'At conversion, the investor has to pay a fixed additional supplementary payment for each share that is bought. This is common practice e.g. in Germany 1€ per share is additionally paid.',

  'grantsOverview.exit.settings.accelerationOnExit.title': 'Acceleration of vesting',
  'grantsOverview.exit.settings.accelerationOnExit.excerpt':
    'If activated, we calculate the actual package value with consideration of the acceleration option for vesting schedules.',

  'grantsModelling.settings.form.csOptionValue.title': 'Expected exit proceeds per share',
  'grantsModelling.settings.form.csOptionValue.excerpt':
    'Shows the expected exit proceeds of a common share option, taking into account all current special rights and the shareholder structure.',

  'payoutStructure.help.default.title': 'Payout structure in case of an exit-event.',
  'payoutStructure.help.default.excerpt':
    'Share classes often have different seniority levels, which define the order of payouts in case of an exit-event. The preference amounts for different share classes are for example defined by the agreed liquidation preferences. However, sometimes the parties agree to additional clauses for payout levels to compensate some groups. I.e. a founder-catch up is a common example to guarantee founders a certain compensation even for lower exit events. You can add these extra clauses here to customize the exit-distribution in the waterfall calculations.',

  'userProfile.companyURL': 'Company URL',
  'userProfile.companyInfo.urlRequired': 'Company URL is required',
  'liquidationPreference.customSharePrice.default.title': 'Alternative Share Price',
  'liquidationPreference.customSharePrice.default.excerpt':
    'If provided, the nominal amount for the calculation of the preference amounts is based on the fixed alternative share price, instead of the paid price by the investors that resulted from the provided investment amount.',
  'liquidationPreference.customSharePrice.default.link':
    'https://ventury-analytics.de/academy/wiki',

  'groupPage.members.tooltipOrga.title': 'Organization',
  'groupPage.members.tooltipOrga.excerpt':
    'This is your organization overview page. Here you can manage your members and activate premium access for your different projects.',
  'groupPage.packages.tooltipPackages.title': 'Packages',
  'groupPage.packages.tooltipPackages.excerpt':
    'In the "Packages" section you can see how many packages you have already purchased.  You can also check how many contingents are still available in a package, when they expire and for which projects some of them have already been used.',
  'generalInformation.guidedTour.title': 'General Information on where to find what',
  'groupPage.packages.tooltipProjects.title': 'Projects',
  'groupPage.packages.tooltipProjects.excerpt':
    'This is the overview of all projects belonging to the organization. By clicking on "Join" you can join as many projects as you like. Here you can also use your contingents to turn projects into premium projects. Please note that a contingent is consumed irrecoverably.',
  'groupPage.packages.tooltipProjects.link': 'General Information on where to find what',

  'generalInformation.guidedTour.excerpt':
    "Termsheet: Contains the most important points, which are later incorporated into the participation & shareholder agreement.Investment Angreement: Pre- & post-money valuation, Conversion of loans, Milestones / valuation adjustments, dilution protection, Shareholders' Agreement: liquidation preferences, Drag and Tag Along, Vesting, ESOP / Option Plans, Right of first Refusal",
  'generalInformation.guidedTour.link': null,
  'generalInformation.modelling.title': 'How to use the modelling',
  'generalInformation.modelling.excerpt': null,
  'generalInformation.modelling.link': null,
  'generalInformation.roundingModes.title': 'Rounding rules for shares',
  'generalInformation.roundingModes.excerpt':
    'Define the rounding rules for shares that are given out. E.g. always floor the investment/price to determine the amount of shares.',
  'generalInformation.roundingModes.link': null,
  'generalInformation.default.title': null,
  'generalInformation.default.excerpt': null,
  'generalInformation.default.link': null,
  'capTable.default.title': 'Capitalization Table',
  'capTable.default.excerpt':
    'A view of the shareholder structure of the company. It contains a detailed description of all the owners of stock of a company.',
  'capTable.default.link': null,
  'companyName.guidedTour.title': 'Company Name',
  'companyName.guidedTour.excerpt': 'The Name of the company you want to create the profile for.',
  'companyName.guidedTour.link': null,
  'companyName.default.title': null,
  'companyName.default.excerpt': null,
  'companyName.default.link': null,
  'exitOverview.dateInput.title': 'Exit Date',
  'exitOverview.dateInput.excerpt':
    'The potential date for an exit. It is important as the vesting schedules and dividends for convertible notes, debt and preference amounts are calculated on the basis of it.',
  'exitOverview.dateInput.link': null,
  'equityHolding.default.title': 'Equity Holding',
  'equityHolding.default.excerpt':
    'Fully-diluted, i.e., taking into account all VESOP shares allocable under the VESOP. NOT corresponding to waterfall proceeds due to Liq.Pref.',
  'equityHolding.default.link': null,
  'securities.slider.title': 'Slider information',
  'securities.slider.excerpt':
    'The slider helps you to flip through the detailed share distributions considering the inclusion of different levels of virtual shares.',
  'securities.slider.link': null,
  'securities.shares.title': 'Shares',
  'securities.shares.excerpt':
    'The legally relevant distribution of the shares. Excluding any virtually granted shares, created ESOP pools or vesting.',
  'securities.shares.link': null,
  'securities.vested.title': 'Including vested shares',
  'securities.vested.excerpt':
    'A vested share distribution is shown, including only vested shares (on todays basis), excluding virtual shares (e.g. granted shares or ESOP pools).',
  'securities.vested.link': null,
  'securities.esop.title': 'Including ESOP',
  'securities.esop.excerpt':
    'The virtual share distribution is shown, including Grants and ESOPs. This is the fully-diluted basis.',
  'securities.esop.link': null,
  'securities.exit.title': 'At an exit event',
  'securities.exit.excerpt':
    'The virtual share distribution is shown as if an exit event happens. It is fully diluted and includes acceleration of vesting.',
  'securities.exit.link': null,
  'guided.esop.title': 'Employee Stock Ownership Plans',
  'guided.esop.excerpt':
    'Add an employee option stock pool. You will have the option to add granted shares and vesting later via the ESOP menu.',
  'guided.esop.link': null,
  'waterfall.diagram.title': 'Waterfall Diagram',
  'waterfall.diagram.excerpt':
    'The waterfall diagram shows the exit returns for different exit valuations. The preference amounts including dividends are calculated on the basis of the exit date.',
  'waterfall.diagram.link': null,
  'waterfall.capPoint.title': 'Cap Point',
  'waterfall.capPoint.excerpt':
    'At this exit amount the share will be capped. However, the effective cap point can be earlier due to conversions based on the exit amount. For the effective cap point see the exit specific table.',
  'waterfall.capPoint.link': null,
  'waterfall.conversionPoint.title': 'Conversion Point',
  'waterfall.conversionPoint.excerpt':
    'At this exit amount the share will be converted to common shares, as a pro-rata participation is economically more beneficial for the shareholders.',
  'waterfall.conversionPoint.link': null,
  'waterfall.strikePoint.title': 'Strike Point',
  'waterfall.strikePoint.excerpt':
    'At this exit amount the employee will exercise the option as it becomes economically viable based on the strike price.',
  'waterfall.strikePoint.link': null,
  'companyInfo.existFounded.title': 'EXIST',
  'companyInfo.existFounded.excerpt': 'EXIST is a Grant Program from the German government.',
  'companyInfo.existFounded.link': 'https://www.exist.de/EN/Programme/About-EXIST/content.html',
  'companyInfo.investGrant.title': 'INVEST',
  'companyInfo.investGrant.excerpt':
    'INVEST is a Venture Grant program from the German government.',
  'companyInfo.investGrant.link': 'https://www.exist.de/EN/Network/Partners/Invest/inhalt.html',
  'companyInfo.default.title': null,
  'companyInfo.default.excerpt': null,
  'companyInfo.default.link': null,
  'portfolio.exitReturns.title': 'Exit Returns',
  'portfolio.exitReturns.excerpt':
    'The exit returns of the individual projects are calculated based on a potential exit to the post money valuation of the company. The return is based on your (default investor) position in the company.',
  'portfolio.exitReturns.link': null,
  'shareInfo.guidedTour.title': 'Share of Round',
  'shareInfo.guidedTour.excerpt':
    'There are different types of shares within a company. Mostly you will find common shares or preferred shares.',
  'shareInfo.guidedTour.link': 'https://ventury-analytics.de/academy/wiki',
  'shareInfo.default.title': null,
  'shareInfo.default.excerpt': null,
  'shareInfo.default.link': null,
  'antiDilution.default.title': 'Anti-Dilution clause',
  'antiDilution.default.excerpt':
    'A term that provides a price protection for investors in the event a company completes a financing round at a lower valuation then a previous financing round.',
  'antiDilution.default.link': 'https://ventury-analytics.de/academy/wiki',
  'fullRatchet.default.title': 'Full Ratchet',
  'fullRatchet.default.excerpt':
    'This specification of the anti dilution clause allows the investor to be placed in a position as if he had invested for the price of the down-round.',
  'fullRatchet.default.link': null,
  'broadBased.default.title': 'Broad Based',
  'broadBased.default.excerpt':
    'The denominator in weighted average anti-dilution calculations that is based on a fully dilluted view of a company. The opposite is called narrow-based.',
  'broadBased.default.link': null,
  'narrowBased.default.title': 'Narrow Based',
  'narrowBased.default.excerpt':
    'The denominator in weighted average anti-dilution calculations that is based on all the preferred shares. The opposite is called broad-based.',
  'narrowBased.default.link': null,
  'compensation.default.title': 'Compensation',
  'compensation.default.excerpt':
    'Select the shares that the investor will get as a compensation in the event that the anti-dilution provision triggers',
  'compensation.default.link': null,
  'duration.default.title': 'Duration',
  'duration.default.excerpt':
    'The duration determines how long an anti-dilution clause is valid for the investor. In case a share got bought multiple times, the duration is always calculated based on the latest investment.',
  'duration.default.link': null,
  'transferType.default.title': 'Type of Compensation',
  'transferType.default.excerpt':
    'Normally, the investor receives his new shares via a compensatory capital increase at nominal value. However, it is also possible to transfer shares at the expense of other common shareholders.',
  'transferType.default.link': null,
  'liquidationPreference.default.title': 'Liquidation Preference',
  'liquidationPreference.default.excerpt':
    'With this clause the investors may recieve their investment from the proceeds of the liquidation / sale before others. Please specify this clause with the following details.',
  'liquidationPreference.default.link': 'https://ventury-analytics.de/academy/wiki',
  'simpleLiquidationPreference.default.title': 'Simple Liquidation Preference',
  'simpleLiquidationPreference.default.excerpt':
    'In the case of a simple or non-participating liquidation preference, the investor receives his invested amount back, including a possible multiple or dividend. There is no participation in the residual proceeds.',
  'simpleLiquidationPreference.default.link': 'https://ventury-analytics.de/academy/wiki',
  'participatingLiquidationPreference.default.title': 'Participating Liquidation Preference',
  'participatingLiquidationPreference.default.excerpt':
    'With the participating liquidation preference, the investor receives back his investment including a possible multiple as well as dividends and participates in the residual proceeds on the basis of his share quota.',
  'participatingLiquidationPreference.default.link': 'https://ventury-analytics.de/academy/wiki',
  'interestRate.default.title': 'Interest or Dividends',
  'interestRate.default.excerpt':
    'Investors may want to recieve additionaly to their investment an accumulated interest or dividend p.a.',
  'interestRate.default.link': 'https://ventury-analytics.de/academy/wiki',
  'multiple.default.title': 'Multiple',
  'multiple.default.excerpt':
    'Investors may want to recieve x-times their investment back bevor others recive proceeds of the liquidation / sale event.',
  'multiple.default.link': 'https://ventury-analytics.de/academy/wiki',
  'senior.default.title': 'Seniority',
  'senior.default.excerpt':
    'Normally the liquidation preferences of the last investments will be served first. Last In - First Out',
  'senior.default.link': 'https://ventury-analytics.de/academy/wiki',
  'remainingProceeds.default.title': 'Remaining Proceeds',
  'remainingProceeds.default.excerpt':
    'Please select how the remaining proceeds will be distributed to the shareholders. Pro-rata: The remaining proceeds will be distributed based on the quota on equity capital held by each shareholder.  ',
  'remainingProceeds.default.link': 'https://ventury-analytics.de/academy/wiki',
  'voluntaryConversion.default.title': 'Conversion',
  'voluntaryConversion.default.excerpt':
    'A process in which preferred shares is converted into common shares. Mainly done when Liquidation Preferences are non participating or capped.',
  'voluntaryConversion.default.link': null,
  'pricePerShare.guidedTour.title': 'Price per Share',
  'pricePerShare.guidedTour.excerpt':
    'The Price per Share is the As-If-Converted Pre-Money Valuation divided through the sum of all previous shares.',
  'pricePerShare.guidedTour.link': null,
  'pricePerShare.default.title': null,
  'pricePerShare.default.excerpt': null,
  'pricePerShare.default.link': null,
  'numberOfShares.guidedTour.title': 'Number of shares',
  'numberOfShares.guidedTour.excerpt':
    'The number of shares are calculated by dividing the investment amount through the paid price per share.',
  'numberOfShares.guidedTour.link': null,
  'numberOfShares.default.title': null,
  'numberOfShares.default.excerpt': null,
  'numberOfShares.default.link': null,
  'discount.guidedTour.title': 'Discount',
  'discount.guidedTour.excerpt':
    'The number of shares are calculated by dividing the investment amount through the paid price per share.',
  'discount.guidedTour.link': null,
  'discount.default.title': null,
  'discount.default.excerpt': null,
  'discount.default.link': null,
  'maturityDate.guidedTour.title': 'Maturity Date',
  'maturityDate.guidedTour.excerpt':
    'The maturity date is the date when the principal amount of a note, draft or other debt instrument becomes due and is repaid to the investor. It also may trigger a forced conversion',
  'maturityDate.guidedTour.link': null,
  'maturityDate.default.title': null,
  'maturityDate.default.excerpt': null,
  'maturityDate.default.link': null,
  'preMoneyCap.guidedTour.title': 'Pre Money Cap',
  'preMoneyCap.guidedTour.excerpt':
    'The Pre Money Cap is the maximum valuation on which the conversion price for the convertible note is calculated.',
  'preMoneyCap.guidedTour.link': null,
  'preMoneyCap.default.title': null,
  'preMoneyCap.default.excerpt': null,
  'preMoneyCap.default.link': null,
  'cummulative.guidedTour.title': 'Cummulative',
  'cummulative.guidedTour.excerpt': '',
  'cummulative.guidedTour.link': null,
  'cummulative.default.title': null,
  'cummulative.default.excerpt': null,
  'cummulative.default.link': null,
  'preMoneyValuation.default.title': 'Pre-Money Valuation',
  'preMoneyValuation.default.excerpt':
    'The Pre Money Valuation is the Post-Money-Valuation minus the new Investment. The Pre-Money Valuation and also the price per Share may also be calculated on a fully dilluted and as-if-converted basis',
  'preMoneyValuation.default.link': 'https://ventury-analytics.de/academy/wiki',
  'upRound.simulation.title': 'Up Round',
  'upRound.simulation.excerpt':
    'A financing round done at a higher post-money valuation as that of the previous round.',
  'upRound.default.title': null,
  'upRound.default.excerpt': null,
  'upRound.default.link': null,
  'flatRound.simulation.title': 'Flat Round',
  'flatRound.simulation.excerpt':
    'A financing round done at the same post-money valuation as that of the previous round.',
  'flatRound.simulation.link': null,
  'flatRound.default.title': null,
  'flatRound.default.excerpt': null,
  'flatRound.default.link': null,
  'downRound.simulation.title': 'Down Round',
  'downRound.simulation.excerpt':
    'A financing round done at a lower post-money valuation as that of the previous round.',
  'downRound.simulation.link': null,
  'downRound.default.title': null,
  'downRound.default.excerpt': null,
  'downRound.default.link': null,
}

export default messages
